import { Attributes, NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class GetFileSpecDateOverlapQuery extends ValueObject {
 
    public staticFileSpecID: number = 0;

    public fileType: string = "";

    public fileExtension: string = "";

    public fileDelimiter: string = "";

    @Attributes.Date()
    public activeStartDate: Date | null = null;
}